'use client';

import { useState, Fragment } from 'react';
import { OssModal } from './oss-modal';
import { type OssCard } from './card-data';
import { AnimatedLink } from '@/components/AnimatedLink';

export function OssCard({ card, index }: { card: OssCard; index: number }) {
  const [isOssCardModalOpen, setIsOssCardModalOpen] = useState(false);
  const openOssCardModal = () => setIsOssCardModalOpen(true);

  const handleInModalClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    e.stopPropagation();
    openOssCardModal();
  };

  // Replace spaces with hyphens and make the string lowercase
  const id = card.name.toLowerCase().replace(/\s+/g, '-');

  return (
    <Fragment key={index}>
      <OssModal
        name={card.name}
        description={card.description}
        link={card.link}
        icon={card.icon}
        isOpen={isOssCardModalOpen}
        onClose={() => setIsOssCardModalOpen(false)}
      />
      <div
        id={id}
        className="scroll-mt-total-headers-offset text-body group/card relative flex flex-col items-start gap-2 rounded-2xl border border-[#2b2b2b] bg-[#13171B] p-8 text-gradle-green shadow-sm transition-colors duration-300 hover:border-white"
      >
        {card.icon}
        <h4 className="text-eyebrow-strong text-white">{card.name}</h4>
        <div className="max-w-[27.5rem]">
          {/* // make links inside description inhert. We only want to use them inside the modal */}
          <p className="text-body line-clamp-3 text-gray-4 [&_a]:pointer-events-none [&_a]:no-underline">
            {card.description}
          </p>
          <button
            className="text-gray-4 underline underline-offset-4 transition-colors hover:text-white"
            onClick={handleInModalClick}
          >
            Read more
          </button>
        </div>
        <div className="flex h-13 justify-center">
          <AnimatedLink hrefTarget="_blank" href={card.link} linkText="Explore build data" />
        </div>
      </div>
    </Fragment>
  );
}
